module.exports = __webpack_public_path__ + "img/selected0-min.ab360457.png";